<template>
  <section class="page-container">
    <div>
      <h1>Micropolicies</h1>
      <div
        class="btn-top-container">
        <v-button
          type="plain"
          size="mini"
          :disabled="exportDisable"
          @click="handlerDown"
        >Export Excel
        </v-button>
      </div>
    </div>
    <micropolicy-list
      ref="Micropolicies"
      @changeDate='setExportStatus'></micropolicy-list>
  </section>
</template>

<script>
import micropolicyList from './micropolicy/components/micropolicy-list'
import {mapState} from 'vuex'

export default {
  name: 'micropolicy',
  components:{
    micropolicyList,

  },
  data() {
    return{
      exportDisable: true,
      active: 'Micropolicies',
    }
  },
  computed:{
    ...mapState('micropolicy',['activeTab']),
    showExportBtn(){
      return !['Referrer Talks','Partner Links','Referrer Bonus'].includes(this.active)
    }
  },
  watch:{
    activeTab:{
      immediate: true,
      handler(val) {
        if(val){
          this.active =val
        }
      }
    }
  },
  methods: {
    handlerDown() {
      let name = this.active.replace(/\s*/g,'')
      this.$refs[name].handlerDown()
    },
    hanldeImport(){
      this.$router.push({
        path: '/records/micropolicy/import-tracking-number'
      })
    },

    setExportStatus(val){
      this.exportDisable = val.length == 0
    },

    changeTab(){
      this.setActiveTab(this.active)
      this.exportDisable = true
    }
  }
}
</script>
<style lang="scss" scoped>
.page-container{
  position: relative;
  .btn-top-container {
    position: absolute;
    top: 10px;
    right: 0;
  }
}
</style>
